import React, { useState } from 'react';
import {
  Box,
  Button,
  ButtonGroup,
  Popover,
  TextField,
  Typography,
} from '@mui/material';
import {
} from '@mui/icons-material';

const TimeRangeSelector = ({ 
  timeRange, 
  customDateRange, 
  onTimeRangeChange, 
  onCustomDateChange 
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [tempStartDate, setTempStartDate] = useState(customDateRange.startDate || '');
  const [tempEndDate, setTempEndDate] = useState(customDateRange.endDate || '');

  const timeRanges = [
    { value: '7d', label: '7 Days' },
    { value: '30d', label: '30 Days' },
    { value: '90d', label: '90 Days' },
    { value: 'custom', label: 'Custom' }
  ];

  const handleCustomClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCustomDateApply = () => {
    if (tempStartDate && tempEndDate) {
      onCustomDateChange(tempStartDate, tempEndDate);
    }
    handleClose();
  };

  const handleCustomDateCancel = () => {
    setTempStartDate(customDateRange.startDate || '');
    setTempEndDate(customDateRange.endDate || '');
    handleClose();
  };

  const open = Boolean(anchorEl);

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <ButtonGroup variant="outlined" size="small">
        {timeRanges.map((range) => (
          <Button
            key={range.value}
            onClick={(event) => {
              if (range.value === 'custom') {
                handleCustomClick(event);
              } else {
                onTimeRangeChange(range.value);
              }
            }}
            variant={timeRange === range.value ? 'contained' : 'outlined'}
            sx={{ minWidth: 80 }}
          >
            {range.label}
          </Button>
        ))}
      </ButtonGroup>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <Box sx={{ p: 3, minWidth: 300 }}>
          <Typography variant="h6" gutterBottom>
            Custom Date Range
          </Typography>
          
          <Box display="flex" flexDirection="column" gap={2}>
            <TextField
              label="Start Date"
              type="date"
              value={tempStartDate}
              onChange={(e) => setTempStartDate(e.target.value)}
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                max: tempEndDate || undefined
              }}
            />
            
            <TextField
              label="End Date"
              type="date"
              value={tempEndDate}
              onChange={(e) => setTempEndDate(e.target.value)}
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                min: tempStartDate || undefined,
                max: new Date().toISOString().split('T')[0]
              }}
            />
          </Box>
          
          <Box display="flex" gap={1} mt={2}>
            <Button 
              variant="contained" 
              onClick={handleCustomDateApply}
              disabled={!tempStartDate || !tempEndDate}
            >
              Apply
            </Button>
            <Button variant="outlined" onClick={handleCustomDateCancel}>
              Cancel
            </Button>
          </Box>
        </Box>
      </Popover>
    </Box>
  );
};

export default TimeRangeSelector; 